import { Link } from "react-router-dom";
import { categories } from "@/mocks/navCategories";

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-200 mt-16">
      <div className="w-full px-4 md:px-6 py-10 md:py-12">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-16">
          <div className="lg:w-[320px] shrink-0">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading font-extrabold text-lg">
                51
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                51网址导航
              </span>
            </div>
            <p className="mt-4 text-sm leading-6 text-secondary-300">
              分类齐全的实用网址导航，把生活、购物、娱乐、学习的高频入口整理到一起，少走弯路，直达目标。
            </p>
            <p className="mt-4 text-xs text-secondary-400">
              本站网址资料由编辑人工维护，当前为前端模拟数据演示。
            </p>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-x-4 gap-y-6">
            {categories.slice(0, 8).map((cat) => (
              <div key={cat.id}>
                <h4 className="text-sm font-medium text-background-50 mb-3">
                  <Link
                    to={`/category/${cat.id}`}
                    className="hover:text-accent-400 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </h4>
                <ul className="space-y-2">
                  {cat.children.map((child) => (
                    <li key={child.id}>
                      <Link
                        to={`/category/${cat.id}`}
                        className="text-xs text-secondary-300 hover:text-background-50 cursor-pointer"
                      >
                        {child.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="lg:w-[200px] shrink-0">
            <h4 className="text-sm font-medium text-background-50 mb-3">关于本站</h4>
            <ul className="space-y-2 text-xs">
              <li>
                <Link to="/about" className="text-secondary-300 hover:text-background-50 cursor-pointer">
                  网站介绍
                </Link>
              </li>
              <li>
                <Link to="/about#feedback" className="text-secondary-300 hover:text-background-50 cursor-pointer">
                  提交网址 / 反馈
                </Link>
              </li>
              <li>
                <Link to="/about#privacy" className="text-secondary-300 hover:text-background-50 cursor-pointer">
                  隐私说明
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-secondary-300 hover:text-background-50 cursor-pointer">
                  联系方式
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            © 2026 51网址导航 · 内容仅供参考，外部网站内容由第三方提供
          </p>
          <div className="flex items-center gap-4 text-xs text-secondary-400">
            <span className="flex items-center gap-1">
              <i className="ri-mail-line" />
              hello@51nav.example.com
            </span>
            <span className="hidden sm:flex items-center gap-1">
              <i className="ri-file-list-3-line" />
              京ICP备 00000000号（演示）
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}